// extracted by mini-css-extract-plugin
export default {"ForgotPassword":"ForgotPassword_ForgotPassword__z5J1Z"};